import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Button,
  Stack,
} from "@mui/material";
import { useSaveClippingConfig } from "../../../hooks/useClipping/useSaveClippingConfig";

export const ModalEditConfig = ({
  open,
  onClose,
  token,
  userId,
  documentId,
  config = {},
  isEdit = false,
  isSection = false,
  refresh,
}) => {
  const [portada, setPortada] = useState(false);
  const [indice, setIndice] = useState(false);
  const [separador, setSeparador] = useState(false);

  const { saveConfig, loading } = useSaveClippingConfig({ token });

  useEffect(() => {
    if (open) {
      setPortada(!!config?.Portada);
      setIndice(!!config?.Indice);
      setSeparador(!!config?.Separador);
    }
  }, [open, config]);

  const handleSave = async () => {
    const result = await saveConfig({
      isEdit,
      isSection,
      config: { ...config, Portada: portada, Indice: indice, Separador: separador },
      userId,
      documentId,
    });

    if (result.success) {
      refresh();
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" mb={2}>
          {isEdit ? "Editar" : "Agregar"} configuración
        </Typography>

        <Stack spacing={2}>
          <FormControlLabel
            control={
              <Switch
                checked={portada}
                onChange={(e) => setPortada(e.target.checked)}
              />
            }
            label="Portada"
          />
          <FormControlLabel
            control={
              <Switch
                checked={indice}
                onChange={(e) => setIndice(e.target.checked)}
              />
            }
            label="Índice"
          />
          <FormControlLabel
            control={
              <Switch
                checked={separador}
                onChange={(e) => setSeparador(e.target.checked)}
              />
            }
            label="Separador"
          />

          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Guardando..." : isEdit ? "Actualizar" : "Agregar"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
